import * as GSA from './GlobalSearchAccess.js'

export const GlobalSearchAccess = GSA.default
